import { render } from "./ExamDownloadOffcanvas.vue?vue&type=template&id=c46a30ca&scoped=true"
import script from "./ExamDownloadOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamDownloadOffcanvas.vue?vue&type=script&lang=js"

import "./ExamDownloadOffcanvas.vue?vue&type=style&index=0&id=c46a30ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46a30ca"]])

export default __exports__